import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {SessionResponse, User, UserPermissions} from "./auth-http.interface";

@Injectable({
  providedIn: 'root'
})
export class AuthHttpService {
  httpClient: HttpClient = inject(HttpClient);

  signIn(identifier: string, password: string) {
    return this.httpClient.post<SessionResponse>('/auth/local', { identifier, password });
  }

  changePassword(currentPassword: string, password: string, passwordConfirmation: string) {
    return this.httpClient.post('/auth/change-password', { currentPassword, password, passwordConfirmation });
  }

  oauthSignIn() {
    return this.httpClient.get('/connect/microsoft')
  }

  getPermissions(roleId: number) {
    return this.httpClient.get<UserPermissions>(`/users-permissions/roles/${roleId}?populate=*`);
  }

  getMe() {
    return this.httpClient.get<User>('/users/me', {params: { populate: 'role' }});
  }

  updateUser(id: number, {id: _id, ...user}: Partial<User>) {
    return this.httpClient.put<User>(`/account/me`, user);
  }
}
